// WP-3.8 (M20 RE-1, S-27 `/reports`): the gallery — one card per RE-1 family, fetched
// dynamically from the engine's own REPORT_FAMILIES. WP-5.1 adds RE-2's own "Position over
// time" card, hardcoded rather than fetched: its data is a persisted Snapshot table
// (packages/api), not one of `queryReport`'s pure, DB-free engine families, so it can't join
// the same dynamic list without breaking that layer's own architecture. WP-5.4 adds RE-2's
// remaining two families — "Aging" (SC-7) and "Fee % by channel" (FE-3) — as genuine
// `REPORT_FAMILIES` entries instead: both are pure, DB-free computations just like the
// original seven, so they appear here with zero new web code beyond a column mapping
// (`REPORT_COLUMNS`/`REPORT_PRIMARY_COLUMN` in lib/reports.ts). WP-7.4 adds a "Zakat" card the
// SAME hardcoded way "Position over time" already is — it's settings-gated (RE-5, off until
// enabled), not one of the REPORT_FAMILIES either.
import { BarChart3, HandCoins, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useReportGallery } from '../lib/reports';
import { useSettings } from '../lib/settings';

export function ReportsPage(): React.JSX.Element {
  const { data } = useReportGallery();
  const { data: settings } = useSettings();

  return (
    <div>
      <h1 className="mb-4 text-xl font-semibold text-ink">Reports</h1>
      {data === undefined && <p className="text-sm text-muted">Loading…</p>}
      {data !== undefined && (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {data.families.map((f) => (
            <Link
              key={f.key}
              to={`/reports/${f.key}`}
              className="flex flex-col items-start gap-2 rounded-[var(--radius-card)] border border-border bg-surface p-4 hover:border-primary"
            >
              <BarChart3 size={20} className="text-primary" />
              <span className="text-sm font-medium text-ink">{f.label}</span>
            </Link>
          ))}
          <Link
            to="/reports/position-over-time"
            className="flex flex-col items-start gap-2 rounded-[var(--radius-card)] border border-border bg-surface p-4 hover:border-primary"
          >
            <TrendingUp size={20} className="text-primary" />
            <span className="text-sm font-medium text-ink">Position over time</span>
          </Link>
          {settings?.zakatEnabled === true && (
            <Link
              to="/reports/zakat"
              className="flex flex-col items-start gap-2 rounded-[var(--radius-card)] border border-border bg-surface p-4 hover:border-primary"
            >
              <HandCoins size={20} className="text-primary" />
              <span className="text-sm font-medium text-ink">Zakat</span>
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
